import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useIsLoggedIn } from 'hooks/useIsLoggedIn'

export const Route = createFileRoute('/')({
  component: IndexRoute,
})

function IndexRoute() {
  const isLoggedIn = useIsLoggedIn()

  if (isLoggedIn) {
    return <Navigate to="/app" />
  }

  return <Navigate to="/signin" />
}
